<template functional>
  <div class="text-lined">
    <slot />
  </div>
</template>

<script>
export default {
  name: "TextLined"
};
</script>

<style lang="scss">
.text-lined {
  padding: 0 8px;
  position: relative;
  display: inline-block;

  &:before {
    content: "";
    display: block;
    position: absolute;
    border-bottom: 1px solid transparent;
    border-color: inherit;
    left: 0;
    top: 50%;
    margin-top: -1px;
    right: 0;
  }
}
</style>
